import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { CallerInput } from '@/models/caller';

export const createCaller = async (data: CallerInput) => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CreateCaller($data: CallerInputType!) {
        createCaller(data: $data) {
          ...CallerFragment
        }
      }
    `),
    variables: {
      data,
    },
  });

  return response.data?.createCaller;
};
